import { useParams } from 'react-router-dom';
import useAppGroup from '../../helpers/hooks/useAppGroup';
import SubHeader from '../header/SubHeader.react';
import PosPage from './PosPage.react';
import PpcPage from './PpcPage.react';

// TODO :: Stop if app / type is not in constants
// TODO :: make call with pageID to get latest article
var Page = function Page() {
  var _useParams = useParams(),
    app = _useParams.app;
  var appGroup = useAppGroup({
    app: app
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubHeader, {
    route: "pages"
  }), appGroup === 'pos' && /*#__PURE__*/React.createElement(PosPage, null), appGroup === 'ppc' && /*#__PURE__*/React.createElement(PpcPage, null));
};
export default Page;